
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { EditDialog } from '@/types/editDialogType';

import EditDialogHandUp from '@/components/EditDialog/index.vue';
import OrderTopTitle from '@/components/OrderInfo/OrderTopTitle.vue'

import {
  getOrderDispose,
  orderServiceOrderHang,
  orderServiceOrderClose,
  delOrderService,
  chargePrice,
  getOrderDetail,
} from '@/api/orderService';
import {
  checkPermissionCompanyFromOrderType,
  checkPermissionRole,
  checkPermissionUseAndCompany,
} from '@/utils/permission';

import { Type } from '@/types/permissionType';
import { bottomBtnOrderState } from '@/utils/orderStatsUtils';
import OrderInfo from '@/components/OrderInfo/OrderInfo.vue';
import OrderServiceInfo from '@/components/OrderInfo/OrderServiceInfo.vue';
import eventBus from "@/utils/eventBus";

@Component({
  name: 'orderServicerToDetail',
  components: {
    EditDialogHandUp,
    OrderTopTitle,
    OrderInfo,
    OrderServiceInfo
  },
  filters: {

  }
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => {},
  })
  DetailsDataQuery!: any;

  private companyId = '';
  private orderServiceId = '';
  private orderDetail: any = {
    order: {},
    order_service: {}
  };
  private isDetail=true;
  private isTransferOut=false;

  private orderState = 0;
  private topButtonList:any=[]

  private tabList:any=[];
  private showBJD:boolean=false;
  private showComplaintBtn:boolean=false;
  private tabName:any='';

  created() {
    if (this.DetailsDataQuery && this.DetailsDataQuery.order_service_id) {
      this.orderServiceId = this.DetailsDataQuery.order_service_id as any;
      this.companyId = this.DetailsDataQuery.company_id as any;
      this.showBJD = parseInt(this.DetailsDataQuery.showBJD as string) === 1;
      this.showComplaintBtn = parseInt(this.DetailsDataQuery.showComplaintBtn as string) === 1;
      this.tabName = this.DetailsDataQuery.tabName
    } else {
      this.orderServiceId = this.$route.query.order_service_id as any;
      this.companyId = this.$route.query.company_id as any;
      this.showBJD = parseInt(this.$route.query.showBJD as string) === 1;
      this.showComplaintBtn = parseInt(this.$route.query.showComplaintBtn as string) === 1;
      this.tabName = this.$route.query.tabName
    }

    eventBus.$on("orderDetailsTab", (data: any) => {
      this.companyId = data.companyId;
      this.orderServiceId = data.id;
      this.getOrderDispose(this.orderServiceId);
    })

    this.getOrderDispose(this.orderServiceId);
  }

  beforeDestroy() {
    eventBus.$off("orderDetailsTab");
  }

  private getTagsHtml(r: any) {
    let kind = "";
    let kindType = "";
    let abnormal = "";
    let plain = "plain";
    if (parseInt(r.order.order_type) === 1) {
      kind = "其他";
      kindType = "warning";
    } else if (parseInt(r.order.order_type) === 2) {
      kind = "维保";
      kindType = "success";
    } else if (parseInt(r.order.order_type) === 3) {
      kind = "安装";
      kindType = "danger";
    } else if (parseInt(r.order.order_type) === 4) {
      kind = "巡检";
      kindType = "";
      if (parseInt(r.order_service.polling_check_abnormal_count) > 0) {
        abnormal = "巡异";
      }
    } else {
      kind = "维保";
      kindType = "success";
    }

    let source = "";
    if (r.order.customer_company_id === r.order_service.servicer_company_id) {
      source = "内部";
    } else {
      source = "外部";
    }
    if (parseInt(r.order_service.transfer_in) === 1) {
      source = "转入";
    }
    if (parseInt(r.order_service.transfer_out) === 1) {
      source = "转出";
    }

    let charge = "";
    let darkplain = "dark";
    if (parseInt(r.order_service.charge) === 1) {
      charge = "收费";
    }

    let expedited = "";
    if (parseInt(r.order_service.expedited) === 1) {
      expedited = "加急";
    }

    // 2019-05-23 迭代 订单排位
    let ranking = "";
    if (parseInt(r.order_service.is_ranking) === 1) {
      let rankingNum = parseInt(r.order_service.ranking);
      if (rankingNum) {
        ranking = rankingNum + "号";
      }
    }

    // 审核标识
    let check = "";
    if (
      parseInt(r.order.check_state) === 11 ||
      parseInt(r.order.check_state) === 51
    ) {
      check = "审核";
    }

    // 留言
    let mesg = "";
    if (r.order.new_bbs_content && r.order.new_bbs_content.id) {
      mesg = "have";
    }

    if (r.order.is_new_bbs) {
      mesg = "new";
    }

    let urgent = ''
    if (r.order.reminder && parseInt(r.order.reminder.count) > 0) {
      urgent = '已催单' + r.order.reminder.count + '次'
    }

    return [
      {
        type: "",
        label: source,
        plain: darkplain,
      },
      {
        type: kindType,
        label: kind,
        plain: plain,
      },
      {
        type: "danger",
        label: abnormal,
        plain: darkplain,
      },
      {
        type: "danger",
        label: charge,
        plain: darkplain,
      },
      {
        type: "danger",
        label: expedited,
        plain: darkplain,
      },
      {
        type: "danger",
        label: ranking,
        plain: darkplain,
      },
      {
        type: "warning",
        label: check,
        plain: darkplain,
      }, {
        type: "warning",
        label: urgent,
        plain: plain,
      }
    ];
  }
  private confirmButton = false

  private getOrderDispose(orderServiceId:string) {
    const params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_service_id: orderServiceId
    };
    getOrderDispose(params)
      .then((res: any) => {
        if (res.data) {
          this.orderDetail = res.data;
          if (this.orderDetail.order.order_task) {
            this.orderDetail.order.order_task.forEach((element:any) => {
              if (!this.orderDetail.order.order_remark) {
                this.orderDetail.order.order_remark = []
              }
              this.orderDetail.order.order_remark.push({
                classify_name: '',
                remark: "【维修小结】" + element.fix_summary,
                addtime: element.finish_time,
                user_name: element.user_name })
            });
          }
          this.isTransferOut = parseInt(this.orderDetail.order_service.transfer_out) === 1
          if (this.orderDetail.order_service_list && this.isTransferOut) {
            this.tabList = this.orderDetail.order_service_list.filter((s:any) => {
              return s.order_service_id !== this.orderServiceId
            })
            let current = this.orderDetail.order_service_list.filter((s:any) => {
              return s.order_service_id === this.orderServiceId
            })
            this.tabList.unshift(current[0]);
            this.companyName = this.tabList[0].order_service_id
          }
          this.initButtonList(this.orderDetail);
        }
      })
      .catch((err: any) => {
        let msg = err.msg
      });
  }
  private getOrderDetail(orderServiceId:string) {
    const params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_service_id: orderServiceId
    };
    getOrderDetail(params)
      .then((res: any) => {
        if (res.data) {
          this.orderDetail = res.data;
          this.topButtonList = [];
        }
      })
      .catch((err: any) => {
        let msg = err.msg
      });
  }
  private initButtonList(orderDetail:any) {
    this.orderState = bottomBtnOrderState(
      parseInt(orderDetail.order_service.state)
    );
    this.topButtonList = [
      {
        id: 8,
        show: this.showBJD && parseInt(orderDetail.order_service.transfer_out) !== 1 && checkPermissionCompanyFromOrderType(UserModule.getCompanyId, Type.BJD, orderDetail.order.order_type),
        info: '生成报价单'
      },
      { id: 7,
        show: parseInt(orderDetail.order.order_type) !== 4 && parseInt(orderDetail.order_service.transfer_out) !== 1,
        info: '实际收费' },
      { id: 1,
        style: 'color: #f00',
        show: (this.orderState === 1 || this.orderState === 2 || this.orderState === 4 || this.orderState === 5) &&
         parseInt(orderDetail.order_service.transfer_out) !== 1 &&
        checkPermissionCompanyFromOrderType(orderDetail.order_service.servicer_company_id, Type.ORDER_HANDUP, orderDetail.order.order_type) &&
        checkPermissionRole(orderDetail.order_service.servicer_company_id, Type.ORDER_HANDUP),
        info: '挂单' },
      // { id: 2,
      //   show: this.orderState > 1 && this.orderState < 6 &&
      //         parseInt(orderDetail.order_service.transfer_in) !== 1 &&
      //         checkPermissionCompanyFromOrderType(orderDetail.order_service.servicer_company_id, Type.ORDER_CONFIRM_CUSTOMER, orderDetail.order.order_type) &&
      //         checkPermissionRole(orderDetail.order_service.servicer_company_id, Type.ORDER_CONFIRM_CUSTOMER),
      //   info: orderDetail.order.order_type === "4" ? "服务完成" : "代客确认" },
      { id: 3,
        style: 'color: #f00',
        show: (this.orderState === 1 || this.orderState === 2 || this.orderState === 4 || this.orderState === 5) &&
              checkPermissionCompanyFromOrderType(orderDetail.order_service.servicer_company_id, Type.ORDER_CLOSE, orderDetail.order.order_type) &&
              checkPermissionRole(orderDetail.order_service.servicer_company_id, Type.ORDER_CLOSE) && parseInt(orderDetail.order_service.transfer_in) !== 1,
        info: '关闭' },
      // { id: 6,
      //   show: this.orderState === 6 && orderDetail.order_service.evaluate_state !== '1',
      //   info: '评价' },
      { id: 8,
        show: checkPermissionUseAndCompany(UserModule.getCompanyId, Type.ORDER_COMPLAINT_DEAL) && parseInt(orderDetail.order_service.complaint_state) !== 0 && parseInt(orderDetail.order_service.complaint_state) !== 8,
        info: '投诉' },
      { id: 4,
        show: this.orderState === 6 && parseInt(orderDetail.order.order_type) !== 4 &&
        parseInt(orderDetail.order_service.transfer_out) !== 1 &&
        parseInt(orderDetail.order_service.is_return_visit) !== 1 && parseInt(orderDetail.order_service.transfer_in) !== 1 &&
        checkPermissionRole(orderDetail.order_service.servicer_company_id, Type.ORDER_DEAL),
        info: '回访' },
      { id: 5,
        style: "color: #f00",
        show: this.orderState >= 6 && checkPermissionCompanyFromOrderType(orderDetail.order_service.servicer_company_id, Type.ORDER_CLOSE, orderDetail.order.order_type),
        info: '删除' },
    ]
    // console.log(this.topButtonList)
  }
  private editDialogData: any = {
    visible: false,
    title: '',
    name: '',
    inputValue: '',
    inputHint: '',
    cancel: '',
    confirm: '',
    callBack: '',
    rules: []
  };
  private buttonClick(button:any) {
    switch (parseInt(button.id)) {
      case 1:
        this.editDialogData = {
          visible: true,
          title: '挂单原因',
          name: '备注',
          inputValue: '',
          inputHint: '请填写挂单原因',
          cancel: '取消',
          confirm: '确定',
          callBack: 'handUpCallBack',
          rules: [{ required: true, message: '请填写备注', trigger: 'blur' }]
        };
        // 挂单
        break;
      case 2:
        // this.customerConfirm()
        // 代客
        break;
      case 3:
        this.editDialogData = {
          visible: true,
          title: '关闭订单',
          name: '备注',
          inputValue: '',
          inputHint: '请填写备注',
          cancel: '取消',
          confirm: '确定',
          callBack: 'closeOrderCallBack',
          rules: [{ required: true, message: '请填写备注', trigger: 'blur' }]
        };
        // 关闭
        break;
      case 4:
        this.$router.push({
          path: '/OrderServicer/returnvisit',
          query: { orderDetail: JSON.stringify(this.orderDetail) }
        });
        // 回访
        break;
      case 5:
        this.delOrder()
        // 删除
        break;
      case 6:
        // 评价
        break;
      case 7:
        // 添加金额
        this.addPrice(this.orderDetail)
        break;
    }
  }
// 添加金额
private priceVisible: boolean = false;
private addPirceCustomer='0';
private addPirceSS='';
private addPrice(val:any) {
  this.priceVisible = true;
  this.addPirceCustomer = val.order_service.estimated_amount;
  this.addPirceSS = val.order_service.real_price;
}

private addPriceConfirm() {
  const params = {
    user_id: UserModule.getUserId,
    user_name: UserModule.getUserName,
    company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
    id: (this.orderDetail as any).order_service.id,
    price: this.addPirceSS
  };
  chargePrice(params)
    .then((res: any) => {
      this.priceVisible = false;
      this.showSuccessMsg('修改成功');
      this.$emit('refreshList', true);
    })
    .catch((err: any) => {
      let msg = err.msg;
    });
}

private addPriceClose() {
  this.priceVisible = false;
}
// 挂单返回监听
private handUpCallBack(editDialogData: EditDialog) {
  if (!editDialogData.inputValue.trim()) {
    this.showSuccessMsg('请填写挂单原因');
    return;
  }
  const params = {
    user_id: UserModule.getUserId,
    user_name: UserModule.getUserName,
    company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
    order_service_id: (this.orderDetail as any).order_service.id,
    remark: editDialogData.inputValue
  };
  orderServiceOrderHang(params)
    .then((res: any) => {
      editDialogData.visible = false;
      this.showSuccessMsg('挂单成功');
      this.$router.go(-1)
    })
    .catch((err: any) => {
      this.showErrorMsg(err.msg);
    });
}
// 关单返回监听
closeOrderCallBack(editDialogData: EditDialog) {
  if (!editDialogData.inputValue.trim()) {
    this.showSuccessMsg('请填写备注');
    return;
  }
  const params = {
    user_id: UserModule.getUserId,
    user_name: UserModule.getUserName,
    company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
    order_service_id: this.orderDetail.order_service.id,
    remark: editDialogData.inputValue
  };
  orderServiceOrderClose(params)
    .then((res: any) => {
      editDialogData.visible = false;
      this.showSuccessMsg('关闭成功');
      this.$router.go(-1)
    })
    .catch((err: any) => {
      let msg = err.msg;
    });
}
// 删除
private delOrder() {
  this.$confirm('关联任务会一起删除呦~', '确认删除此订单?', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  })
    .then(() => {
      let pamars:any = {
        user_id: UserModule.getUserId,
        user_name: UserModule.getUserName,
        company_id: UserModule.getCompanyId,
        company_name: UserModule.getCompanyName
      };
      pamars.order_service_id = this.orderDetail.order_service.id;
      delOrderService(pamars).then((res:any) => {
        this.showSuccessMsg(res.msg);
        this.$router.go(-1)
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    })
    .catch(() => {});
}
private isNull(val: any) {
  if (val) {
    return val;
  } else {
    return '~';
  }
}

  private companyName = ''
  private companyTabClick(val:any) {
    // if (this.companyName === this.orderServiceId) {
    //   this.getOrderDispose(this.companyName);
    // } else {
    //   this.getOrderDetail(this.companyName)
    // }
    this.getOrderDetail(val)
  }
  // private referesh() {
  //   if (this.companyName && this.companyName !== this.orderServiceId) {
  //     this.getOrderDetail(this.companyName)
  //   } else {
  //     this.getOrderDispose(this.orderServiceId)
  //   }
  // }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
